import { del } from '@si/utils';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

import { queryKeys } from './queryKeys';

interface Params {
  projectId: string;
  inviteId: string;
}

export function useDeleteProjectInvite() {
  const queryClient = useQueryClient();

  const { mutate, error, isPending, isSuccess, reset } = useMutation({
    mutationFn: ({ projectId, inviteId }: Params) =>
      del({
        url: `/projects/${projectId}/team/invites/${inviteId}`,
      }),
    onSuccess: (_, { projectId }) => {
      queryClient.invalidateQueries({
        queryKey: queryKeys.getProjectTeamInvites(projectId),
      });
    },
  });

  const deleteProjectInvite = useCallback((params: Params) => mutate(params), [mutate]);

  return {
    deleteProjectInvite,
    error,
    isPending,
    isSuccess,
    reset,
  };
}
